import { ClientsService } from './../../shared/services/clients/clients.service';
import { LinkupService } from './../../shared/services/link-up/linkup.service';
import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { findInArray, getValueProperty, memoize } from '../../shared/helpers/functions.helpers';
import { CatalogService } from '../../shared/services/catalogs/catalog.service';
import { CopyService } from '../../shared/services/copies/copy.service';
import { ValidatorFormFieldService, ValidatorsPatterns } from '../../shared/services/forms/validator-form-field.service';


@Component({
  selector: 'app-form-requirement-basic-data',
  templateUrl: './form-requirement-basic-data.component.html',
  styleUrls: ['./form-requirement-basic-data.component.scss']
})

export class FormRequirementBasicDataComponent implements OnInit {

  form: FormGroup = this.fb.group({});
  CONTENT_BOUNDS: any[] | any;
  checkboxTerms: any;
  documentTypeList: any[] = [];
  modaltyc = false;

  @Input()
  data: any;

  isLoading = false;

  constructor(
    private readonly fb: FormBuilder,
    private readonly cps: CopyService,
    private readonly _catalog: CatalogService,
    private readonly controlContainer: ControlContainer,
    public validatorFormField: ValidatorFormFieldService,
    private link: LinkupService,
    private clients: ClientsService
  ) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.loadStaticValues()
      .then(() => {
        return this.initControls()
          .finally(() => {
            this.loadData();
          });
      }).finally(()=>{
        this.isLoading = false;
      });
  }

  async loadStaticValues() {
    this.CONTENT_BOUNDS = await this.cps.getCopy("form-requirement-basic-data");
    this.documentTypeList = await this._catalog.documentTypes;
  }

  @memoize()
  async getMessageError(control: { label: string, formControlName: string }, errors: any) {
    const { label, formControlName } = control;
    const formControl = this.form.get(formControlName);
    if (formControl) {
      return this.validatorFormField.getMessageError(label, formControl, errors);
    } else {
      return '';
    }
  }

  async initControls() {
    const form = this.controlContainer.control as FormGroup;
    if (form) {
      this.form = form;
    }
    const PATTERN_FIDEICOMISO = await this.validatorFormField.validatorPattern(ValidatorsPatterns.FIDEICOMISO);
    this.form.addControl("document_type", this.fb.control('30', [Validators.required]));
    this.form.addControl("client_id", this.fb.control('1342764', [Validators.required]));
    this.form.addControl("document_number",
      this.fb.control('', [
        Validators.required,
        Validators.pattern(PATTERN_FIDEICOMISO),
        Validators.minLength(3),
        Validators.maxLength(6)
      ]));
    this.form.addControl("document_type_desc", this.fb.control('', []));
    const documentTypeControl = this.form.get('document_type');
    if (documentTypeControl) {
      const documentType = findInArray(this.documentTypeList, 'id', getValueProperty(this.form.get('document_type'), "value"));
      const parameters = getValueProperty(documentType, 'parameters', []);
      const code = findInArray(parameters, "key", "code");
      this.form.patchValue({
        document_type_desc: code.value
      });
    }
  }

  async loadData() {
    if (this.data) {
      this.form.patchValue(this.data);
    }
  }


}
